import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {GetProposalResponse, Proposal, Solicitation} from './_models'
import {
  ICreateSolicitationData,
  IUpdateSolicitationData,
} from '../../search/create-app-stepper/IAppModels'
import {IReceptionCreate, ReceptionData} from '../../reception/create-app-stepper/IAppModels'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PROPOSTA_URL = `${API_URL}/proposal`

const getProposals = (
  query?: Object,
  page: number = 1,
  limit: number = 10
): Promise<GetProposalResponse> => {
  const params = {
    ...query,
    page,
    limit,
  }

  return axios
    .get(`${PROPOSTA_URL}`, {params})
    .then((d: AxiosResponse<GetProposalResponse>) => d.data)
}

const createProposal = (p: Proposal): Promise<Proposal> => {
  return axios.post(`${PROPOSTA_URL}`, p).then((d: AxiosResponse<Proposal>) => d.data)
}

const updateProposal = (p: Proposal): Promise<Proposal> => {
  return axios.patch(`${PROPOSTA_URL}/${p.id}`, p).then((d: AxiosResponse<Proposal>) => d.data)
}

const deleteProposal = (id: ID): Promise<Proposal> => {
  return axios.delete(`${PROPOSTA_URL}/${id}`).then((d: AxiosResponse<Proposal>) => d.data)
}

const receiveProposals = (ids: ReceptionData[]): Promise<Proposal> => {
  return axios
    .patch(`${PROPOSTA_URL}/receiving/proposals`, {propostas: ids})
    .then((d: AxiosResponse<Proposal>) => d.data)
}

const createSolicitationDocument = (solicitation: ICreateSolicitationData): Promise<Proposal> => {
  return axios
    .post(`${PROPOSTA_URL}/solicitation/create`, solicitation)
    .then((d: AxiosResponse<Proposal>) => d.data)
}

const updateSolicitationDocument = (solicitation: IUpdateSolicitationData): Promise<Proposal> => {
  return axios
    .patch(`${PROPOSTA_URL}/solicitation/update`, solicitation)
    .then((d: AxiosResponse<Proposal>) => d.data)
}

const getProposalById = (id: ID): Promise<Proposal> => {
  return axios.get(`${PROPOSTA_URL}/${id}`).then((d: AxiosResponse<Proposal>) => d.data)
}

const importProposals = (file: File): Promise<Proposal[]> => {
  const formData = new FormData()
  formData.append('', file)

  return axios
    .post(`${API_URL}/upload/charge`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((d: AxiosResponse<Proposal[]>) => d.data)
}

const importScr = (file: File): Promise<Proposal[]> => {
  const formData = new FormData()
  formData.append('', file)

  return axios
    .post(`${API_URL}/upload/scr`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((d: AxiosResponse<Proposal[]>) => d.data)
}

export {
  getProposals,
  createProposal,
  updateProposal,
  deleteProposal,
  getProposalById,
  importProposals,
  receiveProposals,
  createSolicitationDocument,
  updateSolicitationDocument,
  importScr,
}
